<template>
    <div :class="['a-step', show ? 'a-step--active' : '']" v-if="show" tabindex="1">
        <div class="a-step__inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AStep',
    props: {
        name: {
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        }
    },
    setup: (props, ctx) => {
        return {

        }
    },
}
</script>

<style lang="scss">
    .a-step {
        width: 100%;
        min-width: 100%;
    }
</style>